import React, { useContext, useEffect, useRef, useState } from 'react';

import { styled } from 'linaria/react';

import { theme } from '../../Theme';
import { StartpageHtlm } from './StartpageHtlm';

// MAP imports
// import InactiveMarkerIcon from '../../../svg/NewMapPin.png';
// import { StoreContext } from '../../StoreHandler/StoreContext';
// import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
// import throwErrorInDev from '@jetshop/core/helpers/throwErrorInDev';
// import {
//   GoogleMap,
//   LoadScript,
//   Marker,
//   InfoWindow,
// } from '@react-google-maps/api';
import Image from '@jetshop/ui/Image/';

const OuterWrapper = styled('div')`
  margin: 0 auto;
  padding: 0 10px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  max-width: 80rem ${theme.below.lg} {
    flex-direction: column;
    max-width: 650px;
  }

  > div {
    flex: 1;
  }

  .html-wrapper {
    overflow: hidden;
    border-radius: 10px 0 0 10px;

    .startpagehtml-component-wrapper {
      height: 100%;
      display: flex;

      .startpagehtml-component {
        justify-content: center;
      }
    }

    ${theme.below.lg} {
      border-radius: 10px 10px 0 0;
    }
  }

  ${theme.below.lg} {
    > div {
      flex: unset;
    }
  }

   {
    /* Map placeholder */
  }
  .map-placeholder {
    flex: 1;
    border-radius: 0 10px 10px 0;
    overflow: hidden;

    ${theme.below.lg} {
      border-radius: 0 0 10px 10px;
    }
  }
`;

// const MapWrapper = styled('div')`
//   width: 100%;
//   border-radius: 0 10px 10px 0;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;

//   ${theme.below.md} {
//     border-radius: 0 0 10px 10px;
//   }

//   .map-container {
//     width: 100%;
//     height: 500px;

//     ${theme.below.md} {
//       height: 400px;
//     }

//     .gm-style-moc {
//       display: none;
//     }

//     .gm-style-iw {
//       top: 0 !important;
//     }

//     .gm-style-iw-chr {
//       position: absolute !important;
//       left: auto;
//       right: 0;
//     }

//     .gm-style-iw-c {
//       padding: 0 !important;
//     }

//     .gm-style-iw-d {
//       padding: 0 !important;
//       overflow: visible !important;
//     }

//     .info-window-content {
//       margin: 0 !important;
//       width: 100% !important;
//       box-sizing: border-box !important;

//       p {
//         margin: 4px;
//       }
//     }
//   }
// `;

// const LoadingElement = () => <div style={{ height: '100%' }}></div>;

// const StartPageStoresMap = () => {
//   const { storeList } = useContext(StoreContext);
//   const { googleMapsApiKey } = useShopConfig();
//   const ref = useRef();
//   const mapContainerRef = useRef();
//   const [mapsLoaded, setMapsLoaded] = useState(false);
//   const [selectedStore, setSelectedStore] = useState(null);
//   const [isMapFocused, setIsMapFocused] = useState(false);

//   throwErrorInDev(
//     typeof googleMapsApiKey === 'undefined',
//     'Make sure googleMapsApiKey is defined in your shop.config.js. See https://developers.google.com/maps/documentation/javascript/get-api-key'
//   );

//   // Filter out store ID 129 from storeList (same as StoreMap)
//   const filteredStoreList = storeList?.filter(
//     (store) => !(store.id === 129 || store?.extra?.id === 129)
//   );

//   // Filter stores with valid coordinates and exclude northern stores (above ~62°N)
//   const validStores =
//     filteredStoreList?.filter(
//       (store) =>
//         store?.extra?.coordinates?.latitude &&
//         store?.extra?.coordinates?.longitude &&
//         !isNaN(store.extra.coordinates.latitude) &&
//         !isNaN(store.extra.coordinates.longitude) &&
//         store.extra.coordinates.latitude < 62.0 // Exclude stores in the far north
//     ) || [];

//   // Fit bounds to show the main cluster of stores, ensuring we see the whole width of Sweden
//   useEffect(() => {
//     if (validStores.length > 0 && mapsLoaded && !selectedStore) {
//       const bounds = new window.google.maps.LatLngBounds();

//       // Add all stores from the main cluster
//       validStores.forEach((store) =>
//         bounds.extend(
//           new window.google.maps.LatLng(
//             store.extra.coordinates.latitude,
//             store.extra.coordinates.longitude
//           )
//         )
//       );

//       // Ensure we see the whole width of Sweden (approximately 11°E to 24°E)
//       const swedenWest = 11.0;
//       const swedenEast = 24.0;

//       const ne = bounds.getNorthEast();
//       const sw = bounds.getSouthWest();

//       // Extend bounds to include Sweden's full width, but keep the vertical bounds focused on the cluster
//       bounds.extend(new window.google.maps.LatLng(sw.lat(), swedenWest));
//       bounds.extend(new window.google.maps.LatLng(sw.lat(), swedenEast));
//       bounds.extend(new window.google.maps.LatLng(ne.lat(), swedenWest));
//       bounds.extend(new window.google.maps.LatLng(ne.lat(), swedenEast));

//       // Don't zoom in too far on only one marker
//       if (ne && sw && ne.equals(sw)) {
//         const extendPoint1 = new window.google.maps.LatLng(
//           ne.lat() + 0.01,
//           ne.lng() + 0.01
//         );
//         const extendPoint2 = new window.google.maps.LatLng(
//           ne.lat() - 0.01,
//           ne.lng() - 0.01
//         );
//         bounds.extend(extendPoint1);
//         bounds.extend(extendPoint2);
//       }

//       // Use less padding to zoom in more on the cluster
//       ref.current.fitBounds(bounds, { padding: 10 });
//     }
//   }, [mapsLoaded, validStores, selectedStore]);

//   // Pan map to ensure InfoWindow is visible when opened
//   useEffect(() => {
//     if (selectedStore && mapsLoaded && ref.current) {
//       const store = filteredStoreList?.find(
//         (s) => (s?.extra?.id || s?.id) === selectedStore
//       );

//       if (store?.extra?.coordinates) {
//         const position = new window.google.maps.LatLng(
//           store.extra.coordinates.latitude,
//           store.extra.coordinates.longitude
//         );

//         // Get current map bounds
//         const bounds = ref.current.getBounds();
//         if (!bounds) return;

//         const ne = bounds.getNorthEast();
//         const sw = bounds.getSouthWest();

//         // Calculate position relative to viewport
//         const latRange = ne.lat() - sw.lat();
//         const lngRange = ne.lng() - sw.lng();

//         const latPosition = position.lat();
//         const lngPosition = position.lng();

//         // Calculate how close marker is to edges (0 = at edge, 0.5 = center)
//         const latFromSouth = (latPosition - sw.lat()) / latRange;
//         const lngFromWest = (lngPosition - sw.lng()) / lngRange;

//         // InfoWindow appears above marker, so we need space at the top
//         // If marker is in upper portion of map, pan down to make room
//         const needsTopSpace = latFromSouth > 0.7; // Marker in upper 30% of viewport
//         const needsSideSpace = lngFromWest < 0.15 || lngFromWest > 0.85; // Too close to sides

//         if (needsTopSpace || needsSideSpace) {
//           // Calculate new center that gives InfoWindow space
//           // Pan down a bit if marker is too high, center horizontally if too close to sides
//           const newLat = needsTopSpace
//             ? position.lat() - latRange * 0.15 // Pan down 15% of viewport height
//             : ref.current.getCenter().lat();

//           const newLng = needsSideSpace
//             ? position.lng() // Center horizontally on marker
//             : ref.current.getCenter().lng();

//           ref.current.panTo(new window.google.maps.LatLng(newLat, newLng));
//         }
//       }
//     }
//   }, [selectedStore, mapsLoaded, filteredStoreList]);

//   // Enable/disable scrollwheel based on focus
//   useEffect(() => {
//     if (mapsLoaded && ref.current) {
//       ref.current.setOptions({
//         scrollwheel: isMapFocused,
//       });
//     }
//   }, [isMapFocused, mapsLoaded]);

//   // Ensure scrollwheel is enabled when interacting with markers or InfoWindow
//   useEffect(() => {
//     if (mapsLoaded && ref.current && (selectedStore !== null || isMapFocused)) {
//       ref.current.setOptions({
//         scrollwheel: true,
//       });
//       setIsMapFocused(true);
//     }
//   }, [selectedStore, mapsLoaded, isMapFocused]);

//   // Disable scrollwheel when clicking outside the map
//   useEffect(() => {
//     const handleDocumentClick = (e) => {
//       if (mapsLoaded && mapContainerRef.current && isMapFocused) {
//         // Check if click is outside the map container
//         // Also check if it's not an InfoWindow element (Google Maps InfoWindows are rendered outside the map container)
//         const isInfoWindow =
//           e.target.closest('.gm-style-iw') ||
//           e.target.closest('.gm-style-iw-c') ||
//           e.target.closest('.gm-style-iw-d');

//         if (!mapContainerRef.current.contains(e.target) && !isInfoWindow) {
//           setIsMapFocused(false);
//           if (ref.current) {
//             ref.current.setOptions({
//               scrollwheel: false,
//             });
//           }
//         }
//       }
//     };

//     if (isMapFocused) {
//       // Use setTimeout to avoid immediate trigger from the click that enabled focus
//       const timeoutId = setTimeout(() => {
//         document.addEventListener('click', handleDocumentClick);
//       }, 100);

//       return () => {
//         clearTimeout(timeoutId);
//         document.removeEventListener('click', handleDocumentClick);
//       };
//     }
//   }, [isMapFocused, mapsLoaded]);

//   const handleMapInteraction = () => {
//     setIsMapFocused(true);
//     if (mapsLoaded && ref.current) {
//       ref.current.setOptions({
//         scrollwheel: true,
//       });
//     }
//   };

//   if (!googleMapsApiKey) {
//     return null;
//   }

//   return (
//     <MapWrapper
//       ref={mapContainerRef}
//       onClick={handleMapInteraction}
//       onFocus={handleMapInteraction}
//       style={{ outline: 'none' }}
//     >
//       <LoadScript
//         loadingElement={<LoadingElement />}
//         preventGoogleFontsLoading={true}
//         googleMapsApiKey={googleMapsApiKey}
//       >
//         <GoogleMap
//           defaultZoom={6}
//           mapContainerClassName="map-container"
//           defaultCenter={{ lat: 59.247948, lng: 14.755806 }}
//           options={{
//             zoomControl: false,
//             mapTypeControl: false,
//             scaleControl: false,
//             streetViewControl: false,
//             rotateControl: false,
//             fullscreenControl: false,
//             disableDoubleClickZoom: false,
//             scrollwheel: false,
//             draggable: true,
//           }}
//           onLoad={(map) => {
//             ref.current = map;
//             setMapsLoaded(true);
//           }}
//         >
//           {mapsLoaded &&
//             filteredStoreList
//               ?.filter(
//                 (store) =>
//                   store?.extra?.coordinates?.latitude &&
//                   store?.extra?.coordinates?.longitude &&
//                   !isNaN(store.extra.coordinates.latitude) &&
//                   !isNaN(store.extra.coordinates.longitude)
//               )
//               .map((store, index) => {
//                 if (store?.extra === undefined) return null;

//                 const storeId = store?.extra.id || store?.id;
//                 const isSelected = selectedStore === storeId;

//                 return (
//                   <React.Fragment key={storeId || index}>
//                     <Marker
//                       cursor={'pointer'}
//                       icon={{
//                         url: InactiveMarkerIcon,
//                         scaledSize: new window.google.maps.Size(24, 29),
//                         anchor: new window.google.maps.Point(12, 29),
//                       }}
//                       zIndex={index}
//                       position={{
//                         lat: store.extra.coordinates.latitude,
//                         lng: store.extra.coordinates.longitude,
//                       }}
//                       onClick={() => {
//                         setIsMapFocused(true);
//                         if (mapsLoaded && ref.current) {
//                           ref.current.setOptions({
//                             scrollwheel: true,
//                           });
//                         }
//                         setSelectedStore(isSelected ? null : storeId);
//                       }}
//                     />
//                     {isSelected && (
//                       <InfoWindow
//                         onCloseClick={() => {
//                           setIsMapFocused(true);
//                           if (mapsLoaded && ref.current) {
//                             ref.current.setOptions({
//                               scrollwheel: true,
//                             });
//                           }
//                           setSelectedStore(null);
//                         }}
//                         position={{
//                           lat: store.extra.coordinates.latitude,
//                           lng: store.extra.coordinates.longitude,
//                         }}
//                         options={{
//                           pixelOffset: new window.google.maps.Size(0, 0),
//                         }}
//                       >
//                         <div
//                           className="info-window-content"
//                           style={{
//                             background: 'white',
//                             padding: '1em',
//                             minWidth: '200px',
//                             fontSize: '14px',
//                             lineHeight: 1.5,
//                           }}
//                         >
//                           <p>
//                             <strong
//                               dangerouslySetInnerHTML={{
//                                 __html: store.name,
//                               }}
//                             />
//                           </p>
//                           {store?.storeInfo && store?.storeInfo?.address ? (
//                             <div>
//                               <p>{store?.storeInfo?.address}</p>
//                               <p>
//                                 {store?.storeInfo?.zip} {store?.storeInfo?.city}
//                               </p>
//                               {store?.storeInfo?.phone && (
//                                 <p>Telefon: {store?.storeInfo?.phone}</p>
//                               )}
//                             </div>
//                           ) : (
//                             store?.extra?.address1 && (
//                               <div
//                                 dangerouslySetInnerHTML={{
//                                   __html: store?.extra?.address1,
//                                 }}
//                               />
//                             )
//                           )}
//                         </div>
//                       </InfoWindow>
//                     )}
//                   </React.Fragment>
//                 );
//               })}
//         </GoogleMap>
//       </LoadScript>
//     </MapWrapper>
//   );
// };

export const StartPageStoresMapView = ({ html, backgroundColor, image }) => {
  const sizes = [1, 1, 1, 1 / 2, 1 / 3];
  return (
    <OuterWrapper className="startpage-stores-map-view">
      {html && (
        <div className="html-wrapper">
          <StartpageHtlm html={html} backgroundColor={backgroundColor} />
        </div>
      )}
      {/* <StartPageStoresMap /> */}
      <div className="map-placeholder">
        <Image
          src={image?.value}
          alt="Map placeholder"
          sizes={sizes}
          cover={true}
          quality={100}
        />
      </div>
    </OuterWrapper>
  );
};
